import React, {useState} from "react";

import { Pagination } from "react-bulma-components";
import { Box } from "react-bulma-components";
import { Button } from "react-bulma-components";
import { Form } from "react-bulma-components";
import { Columns } from "react-bulma-components";
import VehicleTotals from "./VehicleTotals";
import {useVehiclesData} from "../../../hooks/useVehiclesData";
import {
  getDataFresh, getDepartmentsData, getVehicleMakeData,
  getVehiclesData, getVehicleStatusCount,
} from "../../../state/selectors";
import Spinner from "react-spinner-material";
import {useDispatch, useSelector} from "react-redux";
import {formatDate, getQueryString, onFileChange, readableDate} from "../../../utils";
import { Tabs } from "react-bulma-components";
import FilterHeading from "../../Invoicing/FilterHeading";
import ActiveHeadings from "./headings/ActiveHeadings";
import ActiveRow from "./rows/ActiveRow";
import OrderedRow from "./rows/OrderedRow";
import OrderedHeadings from "./headings/OrderedHeadings";
import ArrivingRow from "./rows/ArrivingRow";
import ArrivingHeadings from "./headings/ArrivingHeadings";
import SoldHeadings from "./headings/SoldHeadings";
import SoldRow from "./rows/SoldRow";
import ForSaleRow from "./rows/ForSaleRow";
import ForSaleHeadings from "./headings/ForSaleHeadings";
import {
  createSetDataFreshAction,
  createSetPartsDataAction,
  createSetVehiclesDataAction
} from "../../../actions/dataActions";
import {useVehicleStatusCountData} from "../../../hooks/useVehicleStatusCountData";
import StatusCount from "./StatusCount";
import SearchBar from "../../Utils/SearchBar";
import HireReadyHeadings from "./headings/HireReadyHeadings";
import HireReadyRow from "./rows/HireReadyRow";
import {useVehicleMakeData} from "../../../hooks/useVehicleMakeData";
import AdvancedVehicleFinder from "./AdvancedVehicleFinder";
import ProcessingSaleHeadings from "./headings/ProcessingSaleHeadings";
import ProcessingSaleRow from "./rows/ProcessingSaleRow";
import axios from "axios";
import {NotificationManager} from "react-notifications";
import {useCapTotalChangesData} from "../../../hooks/useCapTotalChangesData";
import CapTotals from "./CapTotals";
import useSelect from "../../../hooks/useSelect";
import {useDepartmentsData} from "../../../hooks/useDepartmentsData";
import DepartmentPicker from "../../Job/DepartmentPicker";
import WorkshopHeading from "./headings/WorkshopHeadings";
import WorkshopRow from "./rows/WorkshopRow";
import SalesPrepHeadings from "./headings/SalesPrepHeadings";
import SalesPrepRow from "./rows/SalesPrepRow";
import NotSoldHeadings from "./headings/NotSoldHeadings";
import NotSoldRow from "./rows/NotSoldRow";
import SalesStockHeadings from "./headings/SalesStockHeadings";
import SalesStockRow from "./rows/SalesStockRow";

function VehiclesView({history, endpoint}) {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [vehicleStatus, setVehicleStatus] = useState("ACTIVE");
  const [searchText, setSearchText] = useState();
  const [filters, setFilters] = useState({});
  const [currentSearch, setCurrentSearch] = useState();
  const [activeTab, setTab] = useState("fleet");
  const [searchFresh, setSearchFresh] = useState(0);
  const [fileList, setFileList] = useState();
  const [selectedDepartment, setSelectedDepartment] = useState();

  const purchaseTypeOptions = [
    {name: "All", value: "ALL"},
    {name: "None", value:"NONE"},
    {name: "Hire Agreement", value:"HIRE_AGREEMENT"},
    {name: "Fixed Rate", value:"REGULAR"},
    {name: "Lease Agreement", value:"LEASE_AGREEMENT"},
    {name: "Variable Rate", value:"FIXED_MONTHLY_CAPITAL"},
    {name: "Stocking Plan", value:"STOCKING_PLAN"}
  ];

  const [purchaseType, purchaseTypeInput, setPurchaseType] = useSelect({
    label: "Purchase Type",
    initialValue: purchaseTypeOptions[0].value,
    options: purchaseTypeOptions
  })


  const onFileSend = () => {
    if(fileList){
      const conf = {
        url: endpoint+"vehiclescap",
        method: "post",
        data: fileList[0]
      }
      axios(conf).then((res) => {
        dispatch(createSetDataFreshAction(dataFresh + 1));
        setFileList(undefined)
      }).catch(err => {
        NotificationManager.error("There was an error uploading the cap data");
      })
    }
    else {
      NotificationManager.warning("No File was selected for upload")
    }
  }



  let params = {page};
  if(purchaseType){
    params.purchaseType=purchaseType;
  }
  if(selectedDepartment){
    params.department_fin=selectedDepartment;
  }
  if (currentSearch) {
    params.search = currentSearch;
  }
  if (searchFresh) {
    params.searchFresh = searchFresh
  }
  if (activeTab === 'fleet') {
    params.tab = 'fleet';
    if (vehicleStatus !== 'all' && vehicleStatus !== "WORKSHOP" && vehicleStatus !== "SALES_PREP" && vehicleStatus !== "NOT_SOLD" && vehicleStatus !== "HIREREADY" && vehicleStatus !== "FORSALE") {
      params.vehicle_status = vehicleStatus;
    }
    if(vehicleStatus === "NOT_SOLD"){
        params.view = "NOT_SOLD"
    }
    if (vehicleStatus === 'ARRIVING') {
      params.vehicle_status = 'ORDERED';
      params.delivery_date_confirmed = true;
      params.order = 'delivery_date'
    }
    if (vehicleStatus === 'ORDERED') {
      params.order = 'month_due'
    }
    if (vehicleStatus === "WORKSHOP"){
        params.view = "WORKSHOP"
    }
    if (vehicleStatus === 'HIREREADY') {
      //params.vehicle_status = 'ACTIVE'
      params.view = 'HIREREADY'
    }
    if (vehicleStatus === "SALES_PREP"){
        params.view = "SALES_PREP"
    }
    if (vehicleStatus === "FORSALE"){
      params.view = "FORSALE"
    }
  } else {
    params.tab = 'customer'
  }

  for (let filter in filters) {
    if (filters[filter][0] && filters[filter][0][filter]) {
      params[filter] = filters[filter][0][filter];
    }
  }

  const onVehicleUpdate = (index, newVehicle) => {
    let newState = { ...data };
    newState.results[index] = newVehicle;
    dispatch(createSetVehiclesDataAction(newState));
  };

  const onFinanceUpdate = (index, finance) => {
  }

  const onRowChange = (e, index, vehicle) => {
    let newVehicle = {...vehicle, [e.target.name]: e.target.value}
    onVehicleUpdate(index, newVehicle);
  }

  const onRowSave = (vehicle) => {
    const conf = {
      url: endpoint+"listvehicles/"+vehicle.id,
      method: "put",
      data: vehicle
    }
    axios(conf).then(() => {
      dispatch(createSetDataFreshAction(dataFresh + 1))
    })
  }

  let dataFresh = useSelector(getDataFresh);
  const complete = useVehiclesData(params, dataFresh);
  const countLoaded = useVehicleStatusCountData({}, dataFresh);
  const departmentsLoaded = useDepartmentsData({}, dataFresh);

  const capLoaded = useCapTotalChangesData({cap_dif: false}, dataFresh);


  const data = useSelector(getVehiclesData);
  const departments = useSelector(getDepartmentsData);
  const countData = useSelector(getVehicleStatusCount);

  const handleSearch = () => {
    setPage(1);
    setCurrentSearch(searchText);
    setSearchFresh(searchFresh+1);
  };

  const setNewVehicleStatus = (status) => {
    setPage(1)
    setVehicleStatus(status)
  }

  const clear = () => {
    setSearchText("");
    setCurrentSearch("");
    setPage(1);
  };

  const onDepartmentChange = e => {
    setSelectedDepartment(e.target.value);
  }

  if (!complete || !countLoaded || !departmentsLoaded) {
    return (
      <Box>
        <Spinner
          className="spinner-centre"
          size={120}
          spinnerColor={"#3273dc"}
          spinnerWidth={2}
        />
      </Box>
    );
  }

  document.title = "Vehicles";

  return (
    <div>
      <Box>
        <Columns>
          <Columns.Column>
            <Form.Label>Search for a Vehicle</Form.Label>
            <SearchBar
              handleSearch={handleSearch}
              clear={clear}
              setSearchText={setSearchText}
              searchText={searchText}
            />
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Button
                  onClick={() => history.push("/editvehicle")}
                  color="success"
                  className="is-pulled-right"
                >
                  New Vehicle +
                </Button>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column>
            <Form.Label>Cap Upload</Form.Label>
            <Form.Field className={"has-addons"}>
              <Form.Control>
                <Form.InputFile
                  value={fileList}
                  onChange={ e => onFileChange(e, fileList, setFileList)}
                />
              </Form.Control>
              <Form.Control>
                <Button
                  color={"success"}
                  onClick={onFileSend}
                  disabled={!(!!fileList)}
                >
                  Upload
                </Button>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <DepartmentPicker
              selectedDepartment={selectedDepartment}
              departments={departments}
              onDepartmentChange={onDepartmentChange}
            />
          </Columns.Column>
          {purchaseTypeInput}
        </Columns>
      </Box>
      {capLoaded && <CapTotals />}
      <br/>
      <StatusCount data={countData}/>
      <Box>
        <h1 className="title">Vehicles</h1>
        <Tabs type="boxed" fullwidth align="centered">
          <Tabs.Tab active={activeTab === "fleet"} onClick={() => {setTab("fleet"); setNewVehicleStatus('all');}}>
            Fleet
          </Tabs.Tab>
          <Tabs.Tab
            active={activeTab === "customer"}
            onClick={() => {setTab("customer"); setNewVehicleStatus('all');}}
          >
            External Customer Vehicles
          </Tabs.Tab>
        </Tabs>
        {activeTab != "customer" &&
        <Tabs type="toggle" align="centered">
          <Tabs.Tab
            active={vehicleStatus === "EQUIPMENT"}
            onClick={() => setNewVehicleStatus("EQUIPMENT")}
          >
            Equipment
          </Tabs.Tab>
          <Tabs.Tab
            active={vehicleStatus === "all"}
            onClick={() => setNewVehicleStatus("all")}
          >
            All
          </Tabs.Tab>
          <Tabs.Tab
            active={vehicleStatus === "NOT_SOLD"}
            onClick={() => setNewVehicleStatus("NOT_SOLD")}
          >
            All (Not Sold)
          </Tabs.Tab>
          <Tabs.Tab
            active={vehicleStatus === "ORDERED"}
            onClick={() => setNewVehicleStatus("ORDERED")}
          >
            Ordered
          </Tabs.Tab>
          <Tabs.Tab
            active={vehicleStatus === "ARRIVING"}
            onClick={() => setNewVehicleStatus("ARRIVING")}
          >
            Arriving
          </Tabs.Tab>
          <Tabs.Tab
            active={vehicleStatus === "ACTIVE"}
            onClick={() => setNewVehicleStatus("ACTIVE")}
          >
            Active
          </Tabs.Tab>
          <Tabs.Tab
            active={vehicleStatus === "WORKSHOP"}
            onClick={() => setNewVehicleStatus("WORKSHOP")}
          >
            Workshop
          </Tabs.Tab>
          <Tabs.Tab
            active={vehicleStatus === "HIREREADY"}
            onClick={() => setNewVehicleStatus("HIREREADY")}
          >
            Hire Ready
          </Tabs.Tab>
          <Tabs.Tab
            active={vehicleStatus === "SALES_STOCK"}
            onClick={() => setNewVehicleStatus("SALES_STOCK")}
          >
            Sales Stock
          </Tabs.Tab>
          <Tabs.Tab
            active={vehicleStatus === "SALES_PREP"}
            onClick={() => setNewVehicleStatus("SALES_PREP")}
          >
            Sales Prep
          </Tabs.Tab>
          <Tabs.Tab
            active={vehicleStatus === "FORSALE"}
            onClick={() => setNewVehicleStatus("FORSALE")}
          >
            For Sale
          </Tabs.Tab>
          <Tabs.Tab
            active={vehicleStatus === "PENDING_SALE"}
            onClick={() => setNewVehicleStatus("PENDING_SALE")}
          >
            Pending Sale
          </Tabs.Tab>
          <Tabs.Tab
            active={vehicleStatus === "PROCESSING"}
            onClick={() => setNewVehicleStatus("PROCESSING")}
          >
            Processing Sale
          </Tabs.Tab>
          <Tabs.Tab
            active={vehicleStatus === "SOLD"}
            onClick={() => setNewVehicleStatus("SOLD")}
          >
            Sold
          </Tabs.Tab>
        </Tabs>
        }
        <table className="table is-hoverable is-fullwidth is-striped">
          <thead>
          {(vehicleStatus === 'ACTIVE' || vehicleStatus === 'all' || vehicleStatus === "EQUIPMENT") && (
            <ActiveHeadings data={data} vehicleStatus={vehicleStatus} activeTab={activeTab} filters={filters} setFilters={setFilters} setPage={setPage}/>
          )}
          {(vehicleStatus === "NOT_SOLD") && (
              <NotSoldHeadings data={data} vehicleStatus={vehicleStatus} activeTab={activeTab} filters={filters} setFilters={setFilters} setPage={setPage}/>
          )}
          {(vehicleStatus === "WORKSHOP") && (
              <WorkshopHeading data={data} vehicleStatus={vehicleStatus} activeTab={activeTab} filters={filters} setFilters={setFilters} setPage={setPage}/>
          )}
          {(vehicleStatus === 'HIREREADY') && (
            <HireReadyHeadings data={data} vehicleStatus={vehicleStatus} activeTab={activeTab} filters={filters} setFilters={setFilters} setPage={setPage}/>
          )}
          {vehicleStatus === 'ORDERED' &&
            <OrderedHeadings data={data} vehicleStatus={vehicleStatus} activeTab={activeTab} filters={filters} setFilters={setFilters} setPage={setPage}/>
          }
          {vehicleStatus === 'ARRIVING' &&
            <ArrivingHeadings data={data} vehicleStatus={vehicleStatus} activeTab={activeTab} filters={filters} setFilters={setFilters} setPage={setPage}/>
          }
          {vehicleStatus === "SALES_STOCK" &&
            <SalesStockHeadings data={data} vehicleStatus={vehicleStatus} activeTab={activeTab} filters={filters} setFilters={setFilters} setPage={setPage}/>
          }
          {vehicleStatus === 'SALES_PREP' &&
            <SalesPrepHeadings data={data} vehicleStatus={vehicleStatus} activeTab={activeTab} filters={filters} setFilters={setFilters} setPage={setPage}/>
          }
          {(vehicleStatus === 'FORSALE' || vehicleStatus === "PENDING_SALE") && (
            <ForSaleHeadings data={data} vehicleStatus={vehicleStatus} activeTab={activeTab} filters={filters} setFilters={setFilters} setPage={setPage}/>
          )}
          {vehicleStatus === 'PROCESSING' &&
            <ProcessingSaleHeadings data={data} vehicleStatus={vehicleStatus} activeTab={activeTab} filters={filters} setFilters={setFilters} setPage={setPage}/>
          }
          {vehicleStatus === 'SOLD' &&
            <SoldHeadings data={data} vehicleStatus={vehicleStatus} activeTab={activeTab} filters={filters} setFilters={setFilters} setPage={setPage}/>
          }
          </thead>
          <tbody>
          {data.results.map((value, index) => {
              let finance;
              if (value.finance_agreements.length) {
                const agreements = value.finance_agreements.sort((a,b) => new Date(a.start_date) - new Date(b.start_date))
                finance = agreements[0]
              } else {
                finance = {
                  estimated_value: 0,
                  remaining_balance: 0,
                  sold_price: 0,
                  sold_date: "",
                  sale_comments: ""
                }
              }
              if (vehicleStatus === 'ACTIVE' || vehicleStatus === 'all' || vehicleStatus === "EQUIPMENT") {
                return <ActiveRow value={value} finance={finance} activeTab={activeTab}/>
              }
              if(vehicleStatus === "NOT_SOLD"){
                  return <NotSoldRow value={value} finance={finance} activeTab={activeTab}/>
              }
              if(vehicleStatus === "WORKSHOP"){
                  return <WorkshopRow value={value} finance={finance} activeTab={activeTab}/>
              }
              if (vehicleStatus === 'HIREREADY') {
                return <HireReadyRow value={value} finance={finance} activeTab={activeTab} dataFresh={dataFresh} onChange={onVehicleUpdate} index={index} onSave={onRowSave}/>
              }
              if (vehicleStatus === 'ORDERED') {
                return <OrderedRow index={index} onVehicleUpdate={onVehicleUpdate} endpoint={endpoint} value={value} finance={finance} activeTab={activeTab}/>
              }
              if (vehicleStatus === 'ARRIVING') {
                return <ArrivingRow index={index} onVehicleUpdate={onVehicleUpdate} endpoint={endpoint} value={value} finance={finance} activeTab={activeTab}/>
              }
              if (vehicleStatus === "SALES_STOCK"){
                return <SalesStockRow index={index} value={value} finance={finance} activeTab={activeTab} onSave={onRowSave} onChange={onRowChange}/>
              }
              if (vehicleStatus === 'SALES_PREP') {
                return <SalesPrepRow index={index} value={value} finance={finance} activeTab={activeTab} onSave={onRowSave} onChange={onRowChange}/>
              }
              if (vehicleStatus === 'FORSALE' || vehicleStatus === "PENDING_SALE") {
                return <ForSaleRow index={index} value={value} finance={finance} activeTab={activeTab} onSave={onRowSave} onChange={onRowChange}/>
              }
              if (vehicleStatus === 'PROCESSING') {
                return <ProcessingSaleRow value={value} finance={finance} activeTab={activeTab}/>
              }
              if (vehicleStatus === 'SOLD') {
                return <SoldRow value={value} finance={finance} activeTab={activeTab}/>

              }
            }

            )
          }
          </tbody>
        </table>
        <Pagination
          showFirstLast={true}
          onChange={setPage}
          current={page}
          total={Math.ceil(data.count / 25)}
        ></Pagination>
      </Box>
    </div>
  );
}

export default VehiclesView;
